import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template as MarginalColumnContent } from "../../shared/marginal-column";

export default {
    title: "Components/Marginal Column",
    component: "ux-iws-marginal-column",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        buttonLabel: "Service & Contact",
        showButtonOnFullWidth: false,
        breakpointActiveAlways: "1440",
    },
    argTypes: {
        buttonLabel: {
            control: "text",
        },
        showButtonOnFullWidth: {
            control: "boolean",
        },
        breakpointActiveAlways: {
            control: "text",
        },
    },
};

const Template = (args) => html`
    <ux-iws-marginal-column
        button-label="${args.buttonLabel}"
        show-button-on-full-width="${args.showButtonOnFullWidth}"
        breakpoint-active-always="${args.breakpointActiveAlways}"
    >
        ${MarginalColumnContent()}
    </ux-iws-marginal-column>
`;

export const Default = Template.bind({});
